// extracted by css-extract-rspack-plugin
export default {"trigger":"M8T8GqN8zGAYpPVG","popover":"jyN0gfBP2mwE2DRM"};